import React, { Component } from "react";
import { connect } from "react-redux";
import { clearUpdate, getAllAdmissionFormListByStudentId } from "../../actions";
import { Link } from "react-router-dom";
import _ from "lodash";
const keys = require("../../config/keys");

class AdmissionFormList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ShowBtn: false
    };
  }

  componentWillMount() {
    // this.props.getAllAdmissionFormListByStudentId(this.props.auth.userId);
    this.props.getAllAdmissionFormListByStudentId(
      this.props.auth.userId,
      this.props.auth.admissionConfig.AyId
    );
  }
  render() {
    return (
      <div>
        <div className="main-bg">
          <h2 className="page-title sub-title">Academic Programs</h2>

          <div className="card custom-card">
            <ul className="form-list-group">
              {_.sortBy(this.props.admissionFormList, "FormGroupName").map(
                (item, index) => {
                  return (
                    <Link
                      to={
                        item.IsVerify === 1 &&
                        (item.IsActive === 0 || item.IsActive === 1) &&
                        item.StudentId
                          ? `/Account/StudentAccount/AdmissionForm/${
                              this.props.userDetails.IsFilled === 1 ? 2 : 1
                            }/${item.ID}`
                          : item.IsVerify === 0 && item.IsActive === 0
                          ? "#"
                          : `/Account/StudentAccount/AdmissionForm/${
                              this.props.userDetails.IsFilled === 1 ? 2 : 1
                            }/${item.ID}`
                      }
                      className={
                        item.StudentId === null
                          ? item.IsActive === 0
                            ? "form-group-items progressStatus progApply fdisable"
                            : "form-group-items progressStatus progApply"
                          : item.IsVerify === 1
                          ? item.IsVerify === 1 &&
                            (item.IsActive === 0 || item.IsActive === 1) &&
                            item.StudentId
                            ? "form-group-items progressStatus progCompleted"
                            : "form-group-items progressStatus progCompleted fdisable"
                          : "form-group-items progressStatus progInProgress"
                      }
                      key={index}
                    >
                      <div className="progressContent">
                        <div className="program-icon">
                          <i
                            className="fa fa-graduation-cap icon"
                            aria-hidden="true"
                          />
                        </div>
                        <div className="program-details">
                          <p className="mb-0">{item.FormGroupName}</p>
                          <div
                            className="program-discrip"
                            dangerouslySetInnerHTML={{
                              __html: item.Description
                            }}
                          />
                          {item.CoursewiseFees === 1
                            ? item.CourseFees !== " " && (
                                <div className="program-discrip">
                                  <p className="mb-0">
                                    <strong>Form Fees</strong> :{" "}
                                    {item.CourseFees}
                                  </p>
                                </div>
                              )
                            : item.FormFees !== "" && (
                                <div className="program-discrip">
                                  <p className="mb-0">
                                    <strong>Form Fees</strong> : {item.FormFees}
                                  </p>
                                </div>
                              )}
                          {this.state.ShowBtn && (
                            <button
                              className="btn no_print btn btn-success mr-0 btn-payment theme-btn"
                              type="button"
                            >
                              <i className="fa fa-money" aria-hidden="true" />
                              {keys.websiteSetting.signUpContent === "nvu"
                                ? "Online Payment"
                                : "Make Payment"}
                            </button>
                          )}
                        </div>

                        <small>Verify Detail is pending</small>
                      </div>
                      {item.StudentId !== null ? (
                        item.IsVerify ? (
                          <span className="badge badge-pill badge-success">
                            <i
                              className="fa fa-check-circle"
                              aria-hidden="true"
                            />
                            Completed
                          </span>
                        ) : (
                          <div>
                            <span className="badge badge-pill badge-warning">
                              <i
                                className="fa fa-chevron-circle-right margin-bottom"
                                aria-hidden="true"
                              />
                              In-Progress
                            </span>
                          </div>
                        )
                      ) : (
                        <span className="badge badge-pill badge-primary">
                          <i
                            className="fa fa-chevron-circle-right"
                            aria-hidden="true"
                          />
                          Apply
                        </span>
                      )}
                    </Link>
                  );
                }
              )}
            </ul>
          </div>
        </div>
        <p className="main-bg admission-note">
          <strong>Note : </strong>
          <span>You can select form according to your Program.</span>
        </p>
      </div>
    );
  }
}
function mapStateToProps({ auth, update, admissionFormList, userDetails }) {
  return { auth, update, admissionFormList, userDetails };
}
export default connect(mapStateToProps, {
  clearUpdate,
  getAllAdmissionFormListByStudentId
})(AdmissionFormList);



// WEBPACK FOOTER //
// ./src/components/StudentAccount/AdmissionFormList.js